// 工作匹配
export enum jobMatchingEnum {
  "financialRisk" = "金融风险记录查询",
  "socialInfo" = "负面社会安全记录查询",
  "identityInfo" = "手机号实名认证"
}
// 体质仪表
export enum physicalInstrumentEnum {
  "fingerTest" = "手部综合检测",
  "colorTest" = "辨色检测"
}

// 知识与技能
export enum knowledgeAndSkillsEnum {
  "iseEnglish" = "英语口语测试",
  "iseChinese" = "普通话口语测试",
  "gameTestList" = "风险偏好小游戏"
}

// 心理动机
export enum psychologicalMotivationEnum {
  "psyc1" = "大五人格完整版测评",
  "psyc3" = "DISC性格测试",
  "psyc4" = "大五人格核心版测评",
  "psyc5" = "DVF心理风险测评"
}

// 身份核验
export enum FaceVerification {
  "身份证号+视频题抽帧核验版" = 1,
  "身份证拍照+视频题抽帧核验版" = 2,
  "身份证号+人脸拍照实时核验版" = 3,
  "人脸核验(H5页面完成人脸核验)" = 6,
  "其他历史版本" = 5
}

// 标签图标
export enum TagIcon {
  "&#xe627;" = 0, //体质仪表
  "&#xe628;" = 1, //工作匹配
  "&#xe629;" = 2, //知识技能
  "&#xe626;" = 3, //基础素质
  "&#xe625;" = 4, //心理动机
  "&#xe6b4;" = 5 //其他
}
